import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { useEffect, useState } from 'react';
import { recuperarDotacionesXEmpleado } from '../../services/empleado/EmpleadoDotacionService';
import { dateFromDateBack, dateStringF1 } from '../../util/dateUtils';
import { Column } from 'primereact/column';
import { obtenerConfByTipo } from '../../services/Configuracion/ConfiguracionCabService';
import {
    obtenerConfigByCabCodigoNoAwait,
    obtenerConfigByCodigo
} from '../../services/Configuracion/ConfiguracionDetService';
import { Dialog } from 'primereact/dialog';
import DotacionForm from './DotacionForm';
import DotacionImagenes from './DotacionImagenes';
import DotacionBorrar from './DotacionBorrar';

const ListaDotaciones = ({ empleadoId }) => {
    const [cargaDotacion, setCargaDotacion] = useState(false);
    const [lstDotacion, setLstDotacion] = useState([]);
    const [dotacion, setDotacion] = useState({});

    const [lstConfCabGrupo, setLstConfCabGrupo] = useState([]);
    const [lstConfEstado, setLstConfEstado] = useState([]);
    const [lstConfEstadoEntrega, setLstConfEstadoEntrega] = useState([]);
    const [lstConfEstadoDevolucion, setLstConfEstadoDevolucion] = useState([]);

    const [mostrarAdi, setMostrarAdi] = useState(false);
    const [mostrarImagen, setMostrarImagen] = useState(false);
    const [mostrarBorrar, setMostrarBorrar] = useState(false);

    const [tipoRegistroDoc, setTipoRegistroDoc] = useState({});
    const [refresca, setRefresca] = useState(false);

    const CODIGO_TIPO_GRUPODOTACION = 'TDO-0000';
    const CODIGO_TIPO_ESTADODOTACION = 'NOM-0000-0018';
    const CODIGO_ESTADO_ENTREGA = 'NOM-0000-0019';
    const CODIGO_ESTADO_DEVOLUCION = 'NOM-0000-0020';
    const TIPO_REGISTRO_DOCUMENTOS_DOTACION = 'NOM-0000-0015-0008';

    useEffect(() => {
        const recuperaDotacion = async (empleadoId) => {
            try {
                if (empleadoId) {
                    setCargaDotacion(true);
                    const data = await recuperarDotacionesXEmpleado(empleadoId);
                    const listaDotacion = data.map((item) => ({
                        dotacionId: item.dotacionId,
                        empleadoId: item.empleado.empleadoId,
                        grupoDotacionConfId: item.grupoDotacionCab.configuracionCabId,
                        grupoDotacionCodigo: item.grupoDotacionCab.codigo,
                        grupoDotacionNombre: item.grupoDotacionCab.nombre,
                        tipoDotacionConfId: item.tipoDotacionDet.configuracionDetId,
                        tipoDotacionCodigo: item.tipoDotacionDet.codigo,
                        tipoDotacionNombre: item.tipoDotacionDet.nombre,
                        cantidad: item.cantidad,
                        fechaEntrega: dateFromDateBack(item.fechaEntrega),
                        fechaEntregaLit: dateStringF1(dateFromDateBack(item.fechaEntrega)),
                        comentario: item.comentario,
                        estadoConfId: item.estadoConfigDet.configuracionDetId,
                        estadoCodigo: item.estadoConfigDet.codigo,
                        estadoNombre: item.estadoConfigDet.nombre,
                        estadoDotacionConfId: item.estadoDotacionConfigDet.configuracionDetId,
                        estadoDotacionCodigo: item.estadoDotacionConfigDet.codigo,
                        estadoDotacionNombre: item.estadoDotacionConfigDet.nombre,
                        fechaDevolucion: dateFromDateBack(item.fechaDevolucion),
                        fechaDevolucionLit: dateStringF1(dateFromDateBack(item.fechaDevolucion)),
                        estadoDotacionDevolucionConfId:
                            item.estadoDotacionDevueltoConfigDet?.configuracionDetId ?? 0,
                        estadoDotacionDevolucionCodigo:
                            item.estadoDotacionDevueltoConfigDet?.codigo ?? '',
                        estadoDotacionDevolucionNombre:
                            item.estadoDotacionDevueltoConfigDet?.nombre ?? ''
                    }));
                    setLstDotacion(listaDotacion);
                }
            } catch (err) {
                console.error('ERROR: ', err.message);
            } finally {
                setCargaDotacion(false);
            }
        };
        recuperaDotacion(empleadoId);
    }, [empleadoId, refresca]);

    useEffect(() => {
        const recuperaGrupoDotacion = async () => {
            try {
                const data = await obtenerConfByTipo(CODIGO_TIPO_GRUPODOTACION);
                setLstConfCabGrupo(data);
            } catch (err) {
                console.error('ERROR: ', err.message);
            }
        };
        const recuperaEstados = async () => {
            try {
                const [estadoData, entregaData, devolucionData] = await Promise.all([
                    obtenerConfigByCabCodigoNoAwait(CODIGO_TIPO_ESTADODOTACION),
                    obtenerConfigByCabCodigoNoAwait(CODIGO_ESTADO_ENTREGA),
                    obtenerConfigByCabCodigoNoAwait(CODIGO_ESTADO_DEVOLUCION)
                ]);
                setLstConfEstado(estadoData);
                setLstConfEstadoEntrega(entregaData);
                setLstConfEstadoDevolucion(devolucionData);
            } catch (err) {
                console.error('ERROR: ', err.message);
            }
        };
        const recuperaTipoRegDocumentos = async () => {
            try {
                const data = await obtenerConfigByCodigo(TIPO_REGISTRO_DOCUMENTOS_DOTACION);
                setTipoRegistroDoc(data);
            } catch (err) {
                console.error('ERROR: al Obtener tipo Registro', err.message);
            }
        };
        recuperaGrupoDotacion();
        recuperaEstados();
        recuperaTipoRegDocumentos();
    }, []);

    const handleClickNuevo = () => {
        setDotacion({});
        setMostrarAdi(true);
    };

    const handleClickEditar = (data) => {
        setDotacion(data);
        setMostrarAdi(true);
    };

    const handleClickBorrar = (data) => {
        setDotacion(data);
        setMostrarBorrar(true);
    };

    const headerTable = (label, icon) => (
        <div className="flex justify-content-between align-items-center mb-2">
            <span className="text-900 font-bold flex align-items-center">
                <i className={`${icon} mr-2 text-primary`} style={{ fontSize: '1.2rem' }}></i>
                {label}
            </span>
            <Button
                label="Nuevo"
                icon="pi pi-plus"
                className=" p-button-success p-button-sm w-auto shadow-2"
                tooltip="Agregar Nuevo"
                tooltipOptions={{ position: 'top' }}
                onClick={() => handleClickNuevo()}
            />
        </div>
    );

    const bodyAcciones = (row) => {
        return (
            <div className="flex gap-2 justify-content-center">
                <Button
                    icon="pi pi-pencil"
                    className="p-button-rounded p-button-text p-button-warning"
                    onClick={() => handleClickEditar(row)}
                />
                <Button
                    icon="pi pi-trash"
                    className="p-button-rounded p-button-text p-button-danger"
                    onClick={() => handleClickBorrar(row)}
                />
            </div>
        );
    };

    const verImagenes = (data) => {
        setDotacion(data);
        setMostrarImagen(true);
    };

    const bodyArchivo = (row) => {
        return (
            <div className="flex gap-2 justify-content-center">
                <Button
                    icon="pi pi-eye"
                    className="p-button-rounded p-button-text p-button-info"
                    tooltip="Visualizar"
                    onClick={() => verImagenes(row)}
                />
            </div>
        );
    };

    const funcCerrar = () => {
        setRefresca((prev) => !prev);
        setMostrarAdi(false);
    };

    const funcCerrarBorra = () => {
        setRefresca((prev) => !prev);
        setMostrarBorrar(false);
    };

    return (
        <>
            <Card header={headerTable('Dotaciones', 'pi pi-wrench')}>
                <Dialog
                    header="Datos Dotacion"
                    visible={mostrarAdi}
                    onHide={() => setMostrarAdi(false)}
                    style={{ width: '800px' }}
                    breakpoints={{ '960px': '90vw' }}
                >
                    <DotacionForm
                        listaGrupo={lstConfCabGrupo}
                        listaEstado={lstConfEstado}
                        listaEntrega={lstConfEstadoEntrega}
                        listaDevolucion={lstConfEstadoDevolucion}
                        datosDotacion={dotacion}
                        empleadoId={empleadoId}
                        funcCerrar={funcCerrar}
                        tipoRegistroDoc={tipoRegistroDoc}
                    />
                </Dialog>

                <Dialog
                    header="Imagenes de Dotacion"
                    style={{ width: '600px' }}
                    visible={mostrarImagen}
                    onHide={() => setMostrarImagen(false)}
                >
                    <DotacionImagenes datosDotacion={dotacion} tipoRegistro={tipoRegistroDoc} />
                </Dialog>

                <Dialog
                    header="Borrar Dotacion"
                    style={{ width: '600px' }}
                    visible={mostrarBorrar}
                    onHide={() => setMostrarBorrar(false)}
                >
                    <DotacionBorrar datosDotacion={dotacion} funcCerrarBorra={funcCerrarBorra} />
                </Dialog>

                <DataTable
                    value={lstDotacion}
                    tableStyle={{ minWidth: '50rem' }}
                    loading={cargaDotacion}
                    emptyMessage="No hay Dotaciones para el Empleado"
                >
                    <Column header="Grupo" field="grupoDotacionNombre" />
                    <Column header="Item" field="tipoDotacionNombre" />
                    <Column header="Cantidad" field="cantidad" />
                    <Column header="Fecha Entrega" field="fechaEntregaLit" />
                    <Column header="Estado Entrega" field="estadoDotacionNombre" />
                    <Column header="Fecha Devolucion" field="fechaDevolucionLit" />
                    <Column header="Estado Devolucion" field="estadoDotacionDevolucionNombre" />
                    <Column header="Archivo" body={bodyArchivo} />
                    <Column header="Acciones" body={bodyAcciones} />
                </DataTable>
            </Card>
        </>
    );
};

export default ListaDotaciones;
